import { render, staticRenderFns } from "./FrontViewComponent.vue?vue&type=template&id=18f6eeaf&scoped=true"
import script from "./FrontViewComponent.vue?vue&type=script&lang=js"
export * from "./FrontViewComponent.vue?vue&type=script&lang=js"
import style0 from "./FrontViewComponent.vue?vue&type=style&index=0&id=18f6eeaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6eeaf",
  null
  
)

export default component.exports